import type { RefObject } from "react";
import { useEffect, useRef, useState } from "react";

type HookValue<T extends HTMLElement> = {
    ref: RefObject<T | null>;
    isTruncated: boolean;
};

/**
 * Reports whether the referenced element clips its text, so callers can decide to reveal the full
 * value (usually in a tooltip). Re-measures when `text` changes, not when the element resizes.
 */
export const useIsTextTruncated = <T extends HTMLElement = HTMLDivElement>(text: string): HookValue<T> => {
    const ref = useRef<T>(null);

    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const element = ref.current;

        setIsTruncated(Boolean(element && element.scrollWidth > element.clientWidth));
    }, [text]);

    return { ref, isTruncated };
};
